import { EnumSchema } from '../metadata-schema';

export const DoorstroomResultaat: EnumSchema = {
	"type": "string",
	"title": "DoorstroomResultaat",
	"enum": [
		"Doorstroom",
		"Geslaagd",
		"Opstroom",
		"Afstroom",
		"Doublure",
		"Afgewezen",
		"VO verlater",
		"Geen"
	]
};
